
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const DirectoryPage = lazy(() => import('../pages/directory/page'));
const DirectoryDetailPage = lazy(() => import('../pages/directory/detail/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const CommunityThreadPage = lazy(() => import('../pages/community/thread/page'));
const HousingPage = lazy(() => import('../pages/housing/page'));
const JobsPage = lazy(() => import('../pages/jobs/page'));
const GroupsPage = lazy(() => import('../pages/groups/page'));
const MentorshipPage = lazy(() => import('../pages/mentorship/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ToolsPage = lazy(() => import('../pages/tools/page'));
const CostCalculatorPage = lazy(() => import('../pages/tools/cost-calculator/page'));
const SalaryConverterPage = lazy(() => import('../pages/tools/salary-converter/page'));
const VisaQuizPage = lazy(() => import('../pages/tools/visa-quiz/page'));
const ChecklistPage = lazy(() => import('../pages/tools/checklist/page'));
const ToolsBudgetPlannerPage = lazy(() => import('../pages/tools/budget-planner/page'));
const ToolsTimelinePlannerPage = lazy(() => import('../pages/tools/timeline-planner/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/article/page'));
const SeoBlogPage = lazy(() => import('../pages/seo-blog/page'));
const LeadMagnetsPage = lazy(() => import('../pages/lead-magnets/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const CampaignsPage = lazy(() => import('../pages/campaigns/page'));
const HealthcareGuideAmericans = lazy(() => import('../pages/blog/articles/healthcare-guide-americans'));
const CostOfLivingUSAIreland = lazy(() => import('../pages/blog/articles/cost-of-living-usa-ireland'));
const IrishTaxSystemAmericans = lazy(() => import('../pages/blog/articles/irish-tax-system-americans'));
const JobsIrelandAmericans2024 = lazy(() => import('../pages/blog/articles/jobs-ireland-americans-2024'));
const VisaGuideAmericans = lazy(() => import('../pages/blog/articles/visa-guide-americans-ireland'));
const MovingToIrelandCompleteGuide = lazy(() => import('../pages/blog/articles/moving-to-ireland-from-usa-complete-guide'));
const BestCitiesIrelandAmericans = lazy(() => import('../pages/blog/articles/best-cities-ireland-americans'));
const IrishCultureGuideAmericans = lazy(() => import('../pages/blog/articles/irish-culture-guide-americans'));
const BankingFinanceGuideAmericans = lazy(() => import('../pages/blog/articles/banking-finance-guide-americans'));
const PetsIrelandFromUSA = lazy(() => import('../pages/blog/articles/pets-ireland-from-usa'));
const MapPage = lazy(() => import('../pages/map/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const MessagesPage = lazy(() => import('../pages/messages/page'));
const ReferralPage = lazy(() => import('../pages/referral/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminLoginPage = lazy(() => import('../pages/auth/admin-login/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const DataRequestPage = lazy(() => import('../pages/data-request/page'));
const AffiliateDisclosurePage = lazy(() => import('../pages/affiliate-disclosure/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const NewYorkToIreland = lazy(() => import('../pages/locations/new-york-to-ireland'));
const CaliforniaToIreland = lazy(() => import('../pages/locations/california-to-ireland'));
const BostonToIreland = lazy(() => import('../pages/locations/boston-to-ireland'));
const TexasToIreland = lazy(() => import('../pages/locations/texas-to-ireland'));
const ChicagoToIreland = lazy(() => import('../pages/locations/chicago-to-ireland'));
const SeattleToIreland = lazy(() => import('../pages/locations/seattle-to-ireland'));
const FloridaToIreland = lazy(() => import('../pages/locations/florida-to-ireland'));
const CitizenshipPage = lazy(() => import('../pages/citizenship/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/directory',
    element: <DirectoryPage />,
  },
  {
    path: '/directory/:id',
    element: <DirectoryDetailPage />,
  },
  {
    path: '/community',
    element: <CommunityPage />,
  },
  {
    path: '/community/thread/:id',
    element: <CommunityThreadPage />,
  },
  {
    path: '/housing',
    element: <HousingPage />,
  },
  {
    path: '/jobs',
    element: <JobsPage />,
  },
  {
    path: '/groups',
    element: <GroupsPage />,
  },
  {
    path: '/mentorship',
    element: <MentorshipPage />,
  },
  {
    path: '/citizenship',
    element: <CitizenshipPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/tools',
    element: <ToolsPage />,
  },
  {
    path: '/tools/cost-calculator',
    element: <CostCalculatorPage />,
  },
  {
    path: '/tools/salary-converter',
    element: <SalaryConverterPage />,
  },
  {
    path: '/tools/visa-quiz',
    element: <VisaQuizPage />,
  },
  {
    path: '/tools/checklist',
    element: <ChecklistPage />,
  },
  {
    path: '/tools/budget-planner',
    element: <ToolsBudgetPlannerPage />,
  },
  {
    path: '/tools/timeline-planner',
    element: <ToolsTimelinePlannerPage />,
  },
  {
    path: '/blog',
    element: <SeoBlogPage />
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />
  },
  {
    path: '/blog/article/:id',
    element: <BlogArticlePage />,
  },
  {
    path: '/blog/articles/healthcare-guide-americans',
    element: <HealthcareGuideAmericans />,
  },
  {
    path: '/blog/articles/cost-of-living-usa-ireland',
    element: <CostOfLivingUSAIreland />,
  },
  {
    path: '/blog/articles/irish-tax-system-americans',
    element: <IrishTaxSystemAmericans />,
  },
  {
    path: '/blog/articles/jobs-ireland-americans-2024',
    element: <JobsIrelandAmericans2024 />,
  },
  {
    path: '/blog/articles/visa-guide-americans-ireland',
    element: <VisaGuideAmericans />,
  },
  {
    path: '/blog/moving-to-ireland-from-usa-complete-guide',
    element: <MovingToIrelandCompleteGuide />,
  },
  {
    path: '/blog/banking-finance-guide-americans',
    element: <BankingFinanceGuideAmericans />,
  },
  {
    path: '/blog/pets-ireland-from-usa',
    element: <PetsIrelandFromUSA />,
  },
  {
    path: '/blog/articles/best-cities-ireland-americans',
    element: <BestCitiesIrelandAmericans />,
  },
  {
    path: '/blog/articles/irish-culture-guide-americans',
    element: <IrishCultureGuideAmericans />,
  },
  {
    path: '/locations/new-york-to-ireland',
    element: <NewYorkToIreland />,
  },
  {
    path: '/locations/california-to-ireland',
    element: <CaliforniaToIreland />,
  },
  {
    path: '/locations/boston-to-ireland',
    element: <BostonToIreland />,
  },
  {
    path: '/locations/texas-to-ireland',
    element: <TexasToIreland />,
  },
  {
    path: '/locations/chicago-to-ireland',
    element: <ChicagoToIreland />,
  },
  {
    path: '/locations/seattle-to-ireland',
    element: <SeattleToIreland />,
  },
  {
    path: '/locations/florida-to-ireland',
    element: <FloridaToIreland />,
  },
  {
    path: '/map',
    element: <MapPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/messages',
    element: <MessagesPage />,
  },
  {
    path: '/referral',
    element: <ReferralPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/auth/admin-login',
    element: <AdminLoginPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '/data-request',
    element: <DataRequestPage />,
  },
  {
    path: '/affiliate-disclosure',
    element: <AffiliateDisclosurePage />,
  },
  {
    path: '/lead-magnets',
    element: <LeadMagnetsPage />
  },
  {
    path: '/analytics',
    element: <AnalyticsPage />
  },
  {
    path: '/campaigns',
    element: <CampaignsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
